import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AdviserWorkspaceHeader from '../../advisers/AdviserWorkspaceHeader';
import { adviserApi } from '../../advisers/api';
import '../../advisers/Advisers.css';

export default function AdviserInvitationPage({
  clientOwnership = false,
}: {
  clientOwnership?: boolean;
}) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return (
    <div className="adviser-workspace">
      <AdviserWorkspaceHeader
        title={clientOwnership ? 'Accept company ownership' : 'Join an adviser practice'}
      />
      <main className="adviser-invitation">
        <div className="adviser-panel">
          <h1>
            {clientOwnership ? 'Your company workspace is ready' : 'Your practice invitation'}
          </h1>
          <p>
            {clientOwnership
              ? 'Accept using the invited email to take direct ownership of your company. Your adviser keeps approved access to collaborate on planning and execution. You can revoke that access independently of billing.'
              : 'Accept using the account with the invited email address. You will see only the client companies assigned to you by the practice owner.'}
          </p>
          {error && (
            <p className="adviser-error" role="alert">
              {error}
            </p>
          )}
          {token ? (
            <button
              className="adviser-button"
              type="button"
              disabled={busy}
              onClick={async () => {
                setBusy(true);
                setError('');
                try {
                  if (clientOwnership) {
                    const result = await adviserApi.acceptClientOwnership(token);
                    navigate(`/company/${result.companyId}`);
                  } else {
                    const practice = await adviserApi.acceptInvitation(token);
                    navigate(`/adviser?practice=${practice.practiceId}`);
                  }
                } catch (err) {
                  setError(err instanceof Error ? err.message : 'Unable to accept invitation.');
                } finally {
                  setBusy(false);
                }
              }}
            >
              {busy
                ? 'Accepting…'
                : clientOwnership
                  ? 'Accept company ownership'
                  : 'Accept practice invitation'}
            </button>
          ) : (
            <p className="adviser-error">
              The invitation link is incomplete. Ask the practice owner for a new link.
            </p>
          )}
          <p>
            <Link className="adviser-text-link" to="/dashboard">
              Back to my companies
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
